import { render, staticRenderFns } from "./VaimoGoodToKnow.vue?vue&type=template&id=4ebacfdf&scoped=true&"
import script from "./VaimoGoodToKnow.vue?vue&type=script&lang=js&"
export * from "./VaimoGoodToKnow.vue?vue&type=script&lang=js&"
import style0 from "./VaimoGoodToKnow.vue?vue&type=style&index=0&id=4ebacfdf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebacfdf",
  null
  
)

export default component.exports